import * as React from "react";
const SvgRb = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 19, height: 19, rx: 9.5, fill: "none", stroke: "currentColor" }));
export default SvgRb;
